/**
 * ext-components-pro
 *
 * Adapptio: Set of pro components
 *
 * @package ext-components-pro
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { fluentUi as fluentUiEditorComponent } from "./editor/components/FluentThemeProvider";
import { timePicker as timePickerComponent } from "./editor/components/TimePicker";
import { datePicker as datePickerComponent } from "./editor/components/DatePicker";

import { timePicker as timePickerEditorSchema } from "./editor/schemas/TimePicker";
import { datePicker as datePickerEditorSchema } from "./editor/schemas/DatePicker";

export const termsEditor = {
	components: {
		fluentUi: fluentUiEditorComponent,
		datePicker: datePickerComponent,
		timePicker: timePickerComponent
	},

	schemas: {
		datePicker: datePickerEditorSchema,
		timePicker: timePickerEditorSchema
	},
	field: {
		name: {
			label: "schema:field.name#label",
			description: "schema:field.name#description"
		}
	}
};

export const termsRuntime = {
	components: {}
};
